import PropTypes from 'prop-types';

export const MatchType = PropTypes.shape({
  isExact: PropTypes.bool,
  params: PropTypes.shape({}),
  path: PropTypes.string,
  url: PropTypes.string,
});

export const LocationType = PropTypes.shape({
  hash: PropTypes.string,
  pathname: PropTypes.string,
  search: PropTypes.string,
  state: PropTypes.shape({}),
});

export const HistoryType = PropTypes.shape({
  actions: PropTypes.string,
  block: PropTypes.func,
  go: PropTypes.func,
  goBack: PropTypes.func,
  goForward: PropTypes.func,
  length: PropTypes.number,
  listen: PropTypes.func,
  location: LocationType,
  push: PropTypes.func,
  replace: PropTypes.func,
});

export const RouterType = PropTypes.shape({
  history: HistoryType,
  route: PropTypes.shape({
    location: LocationType,
    match: MatchType,
  }),
});



// WEBPACK FOOTER //
// ./src/types/router.js